<template>
    <form-container v-on:save="saveEyp" :disabled="loading">
        <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{translate('draftEyp.createEYP')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" :aria-label="translate('close')" @click="close()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                    <!-- <ul class="nav nav-pills nav-fill" style="">
                        <li v-for="(t, i) in tabs" :key="t.key" v-show="t.visible()" class="nav-item">
                            <a class="nav-link" :class="{active:tab==t.key}" href="#void" @click.prevent="goTab(t.key)">
                                <span class="badge badge-pill badge-primary">{{i}}</span>
                                {{t.text}}
                            </a>
                        </li>
                    </ul> -->
                <tab :tabs="tabs" v-model="tab" ref="tabs"></tab>
                <div class="modal-body" style="height:420px; overflow-y:scroll;">
                    <div v-show="tab == 'dosya'">
                        <div class="row" >
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="version">{{translate('draftEyp.version')}}</label>
                                    <select class="form-control" v-model="data.Version">
                                        <option value="Eyp1">1.3</option>
                                        <option value="Eyp2">2.0</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="ustyaziUpload">{{translate('draftEyp.ustYazi')}}</label>
                                    <div class="input-group">
                                        <div class="form-control">
                                            <div v-if="!ustyaziFile || ustyaziFile.length == 0"  class="texdt-muted" style="font-style:italic; font-size:0.8em; line-height:2em;">{{translate('draftEyp.selectUstyazi')}}</div>
                                            <div v-for="file in ustyaziFile" :key="file.id">
                                                {{file.name}} (<small class="text-muted">{{file.size | prettyBytes}}</small>)
                                                <span class="text-danger" v-if="file.error">{{file.response.Message}}</span>
                                                <div class="progress" v-if="file.active" style="height:4px; position: relative; left: -12px; right: -2px; top: 2px; margin-right: -24px;">
                                                    <div class="progress-bar progress-bar-striped progress-bar-animated text-left" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: file.progress + '%' }">&nbsp;%{{parseInt(file.progress, 10)}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="input-group-append">
                                            <label for="ustyaziUpload" class="btn btn-outline-secondary" type="button" id="button-addon2">{{translate('draftEyp.selectFile')}}</label>
                                        </div>
                                    </div>
                                    <file-upload
                                        style="display:none"
                                        input-id="ustyaziUpload"
                                        ref="ustyaziUpload"
                                        v-model="ustyaziFile"
                                        :post-action="axios.defaults.baseURL + '/' + this.modelName + '/addfile/' + data.Id"
                                        :multiple="false"
                                        :drop="true"
                                        :thread="1"
                                        :headers="uploadHeaders"
                                        @input="$refs.ustyaziUpload.active = true"
                                    >
                                    </file-upload>
                                </div>
                                <div class="form-group">
                                    <label for="ekUpload">{{translate('draftEyp.attachments')}}</label>

                                    <div class="form-control" style="height:100px; overflow-y:auto;">
                                        <div v-if="!ekler || ekler.length == 0" class="texdt-muted" style="font-style:italic; font-size:0.8em; line-height:2em;">{{translate('draftEyp.attachmentsText')}}</div>
                                        <div v-for="file in ekler" :key="file.id" style="padding:2px 0">
                                            <div class="remove" @click="removeEk(file)" style="width:22px; height:22px; display:inline-block; vertical-align:middle;"></div>
                                            {{file.name}} (<small class="text-muted">{{file.size | prettyBytes}}</small>)
                                            <span class="text-danger" v-if="file.error">{{file.response.ModelState.UserException[0]}}</span>
                                            <div class="progress" v-if="file.active">
                                                <div class="progress-bar progress-bar-striped progress-bar-animated text-left" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: file.progress + '%' }">&nbsp;%{{parseInt(file.progress, 10)}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-right" style="padding-top:8px;">
                                        <label for="ekUpload" class="btn btn-sm btn-outline-secondary" type="button" id="button-addon2">{{translate('draftEyp.selectAttachmentFile')}}</label>
                                    </div>
                                    <file-upload
                                        style="display:none"
                                        input-id="ekUpload"
                                        ref="ekUpload"
                                        v-model="ekler"
                                        :post-action="axios.defaults.baseURL + '/' + this.modelName + '/addfilechunk/' + data.Id"
                                        :multiple="true"
                                        :drop="true"
                                        :thread="1"
                                        :headers="uploadHeaders"
                                        @input="$refs.ekUpload.active = true"
                                        chunk-enabled
                                        :chunk="{
                                            headers: {
                                                token: axios.defaults.headers.common['token']
                                            },
                                            action: axios.defaults.baseURL + '/eypattachment/addfilechunk/' + data.Id,
                                            //minSize: 1048576,
                                            minSize:0,
                                            maxActive: 3,
                                            maxRetries: 3,

                                            // Example in the case your backend also needs the user id to operate
                                            startBody: {
                                                //user_id: user.id
                                            }
                                        }"
                                    >
                                    </file-upload>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                    <div v-show="tab == 'genel'">
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label for="konu">{{translate('draftEyp.subject')}}</label>
                                    <input type="text" class="form-control" id="konu" name="Konu" v-model="data.Ustyazi.Konu" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label for="belgeNo">{{translate('draftEyp.documentNo')}}</label>
                                    <input type="text" class="form-control" id="belgeNo"  name="BelgeNo" v-model="data.Ustyazi.BelgeNo"/>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label for="tarih">{{translate('draftEyp.date')}}</label>
                                    <!-- <input type="date" class="form-control" id="tarih" name="tarih" v-model="data.Ustyazi.Tarih" firstDayOfWeek="1" /> -->
                                    <date-input class="form-control"  id="tarih" name="tarih" v-model="data.Ustyazi.Tarih"></date-input>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label for="guvenlikDerecesi">{{translate('draftEyp.securityLevel')}}</label>
                                    <select class="form-control" id="guvenlikDerecesi" name="GuvenlikDerecesi" v-model="data.Ustyazi.GuvenlikDerecesi" >
                                        <option value="TSD">{{translate('draftEyp.securityLevels.tsd')}}</option>
                                        <option value="HZO">{{translate('draftEyp.securityLevels.hzo')}}</option>
                                        <option value="OZL">{{translate('draftEyp.securityLevels.ozl')}}</option>
                                        <option value="GZL">{{translate('draftEyp.securityLevels.gzl')}}</option>
                                        <option value="CGZ">{{translate('draftEyp.securityLevels.cgz')}}</option>
                                        <option value="KSO">{{translate('draftEyp.securityLevels.kso')}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label for="olusturan">{{translate('draftEyp.olusturan')}}</label>
                                    <select class="form-control" @change="setChangedValue($event)"  id="olusturan" name="Olusturan" v-model="data.OlusturanId" >
                                        <option v-for="o in olusturanList" :key="o.Id" :value="o.Id">{{o.DisplayName}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div v-show="tab == 'epdk'" xstyle=" height:400px; padding-right:20px;">
                        <div class="row">
                            <div class="col">
                                <div class="row form-group">
                                    <label class="col-sm-3 col-form-label col-form-label-sm" for="metadataUpload">{{translate('draftEyp.incomingPackage')}}</label>
                                    <div class="col-sm-9">
                                        <div class="input-group input-group-sm">
                                            <div class="form-control">
                                                <div v-if="!metadataFile || metadataFile.length == 0"  class="texdt-muted" style="font-style:italic; font-size:0.8em; line-height:2em;">{{translate('draftEyp.selectIncomingPackageText')}}</div>
                                                <div v-for="file in metadataFile" :key="file.id">
                                                    {{file.name}} (<small class="text-muted">{{file.size | prettyBytes}}</small>)
                                                    <span class="text-danger" v-if="file.error">{{file.error}}</span>
                                                    <div class="progress" v-if="file.active" style="height:4px; position: relative; left: -12px; right: -2px; top: 2px; margin-right: -24px;">
                                                        <div class="progress-bar progress-bar-striped progress-bar-animated text-left" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: file.progress + '%' }">&nbsp;%{{parseInt(file.progress, 10)}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="input-group-append">
                                                <label for="metadataUpload" class="btn btn-outline-secondary" type="button" id="button-addon2">{{translate('draftEyp.selectFile')}}</label>
                                            </div>
                                        </div>
                                        <file-upload
                                            style="display:none"
                                            input-id="metadataUpload"
                                            ref="metadataUpload"
                                            accept=".eyp"
                                            :size="20 * 1024 * 1024"
                                            v-model="metadataFile"
                                            :post-action="axios.defaults.baseURL + '/eyp2/ParseEnvisionMetadata/'"
                                            :multiple="false"
                                            :drop="true"
                                            :thread="1"
                                            :headers="uploadHeaders"
                                            @input="$refs.metadataUpload.active = true"
                                        >
                                        </file-upload>
                                    </div>
                                </div>
                                <div v-if="data.Metadata">
                                    <div class="row form-group">
                                        <label class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.companyType')}}</label>
                                        <div class="col-sm-9">
                                            <select class="form-control form-control-sm" v-model="data.Metadata.EpdkCompanyType">
                                                <option value="Elektrik">{{translate('draftEyp.electric')}}</option>
                                                <option value="Dogalgaz">{{translate('draftEyp.naturalGas')}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.referenceId')}}</label>
                                        <div class="col-sm-9">
                                            <input type="text" readonly class="form-control form-control-sm" v-model="data.Metadata.ReferenceId"/>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.parentCategory')}}</label>
                                        <div class="col-sm-9">
                                            <select class="form-control form-control-sm" v-model="parentCategory">
                                                <option v-for="c in categories" :key="c.category" :value="c">{{c.category}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row form-group" :title="data.Metadata.KategoriKodu">
                                        <label class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.category')}}</label>
                                        <div class="col-sm-9">
                                            <select class="form-control form-control-sm" v-model="data.Metadata.KategoriKodu" v-if="parentCategory">
                                                <option v-for="c in parentCategory.subCategories" :key="c.code" :value="c.code">{{c.name}}</option>
                                            </select>
                                            <div v-else class="text-muted">{{translate('draftEyp.selectParentCategory')}}</div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.epdkAciklama')}}</label>
                                        <div class="col-sm-9">
                                            <textarea v-model="data.Metadata.EpdkAciklama" class="form-control form-control-sm" readonly></textarea>
                                        </div>
                                    </div>
                                    <div class="row form-group" v-show="data.Metadata.EpdkCompanyType == 'Elektrik'">
                                        <label class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.commercialQualityCode')}}</label>
                                        <div class="col-sm-9">
                                            <select v-model="data.Metadata.TicariKaliteKodu" class="form-control form-control-sm">
                                                <option v-for="c in qualityCodes" :key="c.code" :value="c.code">{{c.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.epdkLastAnswerDate')}}</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control-plaintext form-control-sm" :value="data.Metadata.EpdkSonCevapTarihi | date" />
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.answerStatus')}}</label>
                                        <div class="col-sm-9">
                                            <select class="form-control form-control-sm" v-model="data.Metadata.ReferenceType">
                                                <option value="2">{{translate('draftEyp.allAnswerStatus.answer')}}</option>
                                                <option value="3">{{translate('draftEyp.allAnswerStatus.return')}}</option>
                                                <option value="4">{{translate('draftEyp.allAnswerStatus.answerKVKK')}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.description')}}</label>
                                        <div class="col-sm-9">
                                            <textarea class="form-control form-control-sm" v-model="data.Metadata.Aciklama"></textarea>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.isComplainantRight')}}</label>
                                        <div class="col-sm-9">
                                            <span v-if="data.Metadata.SikayetSahibiHakiMi" class="badge badge-success">{{translate('yes')}}</span>
                                            <span v-else class="badge badge-danger">{{translate('no')}}</span>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.hasAppliedBefore')}}</label>
                                        <div class="col-sm-3">
                                            <select class="form-control form-control-sm" v-model="data.Metadata.BasvuruVarMi">
                                                <option :value="true">{{translate('exist')}}</option>
                                                <option :value="false">{{translate('notExist')}}</option>
                                            </select>
                                        </div>
                                        <label class="col-sm-3 col-form-label col-form-label-sm" v-show="data.Metadata.BasvuruVarMi">{{translate('draftEyp.applicationDateBasedOnTime')}}</label>
                                        <div class="col-sm-3" v-show="data.Metadata.BasvuruVarMi">
                                            <date-input v-model="data.Metadata.EsasBasvuruTarihi" class="form-control form-control-sm"></date-input>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.hasProcessFinished')}}</label>
                                        <div class="col-sm-3">
                                            <select class="form-control form-control-sm" v-model="data.Metadata.IslemSonuc">
                                                <option :value="true">{{translate('yes')}}</option>
                                                <option :value="false">{{translate('no')}}</option>
                                            </select>
                                        </div>
                                        <label v-show="data.Metadata.IslemSonuc" class="col-sm-3 col-form-label col-form-label-sm">{{translate('draftEyp.timeBasedDeadline')}}</label>
                                        <div v-show="data.Metadata.IslemSonuc" class="col-sm-3">
                                            <date-input v-model="data.Metadata.SonucEsasTarih" class="form-control form-control-sm"></date-input>
                                        </div>
                                    </div>


                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="row" v-show="tab == 'dagitim'">
                        <div class="col">
                            <table class="table table-sm table-borderless">
                                <thead>
                                    <tr>
                                        <th style="width: 30px; !important"></th>
                                        <th>{{translate('draftEyp.dagitim')}}</th>
                                        <th>{{translate('draftEyp.kind')}}</th>
                                        <th>{{translate('draftEyp.urgency')}}</th>
                                        <th style="width:50px;">{{translate('draftEyp.target')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="d,counter in data.Dagitim" :key="d.Id">
                                        <td class="remove" @click="removeDagitim(d)"></td>
                                        <td>
                                            <!-- <select class="form-control" v-model="d.OzneId" >
                                                <option v-for="o in dagitimList" :key="o.Id" :value="o.Id">{{o.DisplayName}}</option>
                                            </select> -->
                                            <select-input
                                                :value="d.OzneId"
                                                :index="counter"
                                                :autocomplete="true"
                                                placeholder="Ara..."
                                                name="Dagitim"
                                                :items="dagitimList"
                                                :filter-function="(item, search) => new RegExp(search, 'i').test(item.DisplayName)"
                                                @change="dagitimSelectChanged"
                                                style="width:100%; min-width: 300px; max-width: 330px;">
                                                <span>{{ d.DisplayName }}</span>
                                                    <template v-slot:item="{item}">
                                                        <div style="padding:2px 0;">
                                                            {{item.DisplayName}}
                                                        </div>
                                                    </template>
                                            </select-input>
                                        </td>
                                        <td>
                                            <select class="form-control" style="min-width: 115px;" v-model="d.DagitimTuru" >
                                                <option value="BLG">{{translate('draftEyp.info')}}</option>
                                                <option value="GRG">{{translate('draftEyp.geregi')}}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select class="form-control" v-model="d.Ivedilik" >
                                                <option value="NRM">{{translate('draftEyp.urgencyOptions.nrm')}}</option>
                                                <option value="IVD">{{translate('draftEyp.urgencyOptions.ivd')}}</option>
                                                <option value="CIV" v-if="data.Version == 'Eyp1'">{{translate('draftEyp.urgencyOptions.civ')}}</option>
                                                <option value="GNL">{{translate('draftEyp.urgencyOptions.gnl')}}</option>
                                            </select>
                                        </td>
                                        <td class="text-center">
                                            <input type="checkbox" v-model="d.IsHedef" />
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td class="text-right">
                                            <button class="btn btn-outline-info btn-sm" style="width: fit-content; min-width: 132px;" type="button" @click="detsisRequestModal = true">{{translate('draftEyp.requestTarget')}}</button>
                                        </td>
                                        <td class="text-right">
                                            <button class="btn btn-outline-info btn-sm" style="width: max-content" type="button" @click="addDagitim()">{{translate('draftEyp.addDagitim')}}</button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="row" style="width:100%;">
                        <div class="col col-8">
                            <!-- <div class="btn-group">
                                <button type="button" :disabled="!$refs.tabs || !$refs.tabs.prevTab" @click="$refs.tabs.goPrevTab()" class="btn btn-outline-info">« Geri</button>
                                <button type="button" :disabled="!$refs.tabs || !$refs.tabs.nextTab" @click="$refs.tabs.goNextTab()" class="btn btn-outline-info">İleri »</button>
                            </div> -->
                            <tab-nav v-model="tab" :tabs="tabs" :nextButton="false"></tab-nav>
                            
                            <span class="text-primary" v-show="saving" style="padding-left:20px;">
                                <!-- <img src="../assets/loading_blue.gif" /> -->
                                <spinner/>
                                {{translate('processingMessages.eypCreating')}}
                            </span>
                            <span class="text-primary" v-show="uploading" style="padding-left:20px;">
                                <!-- <img src="../assets/loading_blue.gif" /> -->
                                <spinner/>
                                {{translate('processingMessages.filesUploading')}}
                            </span> 
                        </div>
                        <div class="col col-4 text-right"> 
                            <tab-nav v-model="tab" :tabs="tabs" :prevButton="false" style="margin-right:12px;"></tab-nav>
                            <button v-show="tab == 'dagitim'" type="submit" :disabled="uploading" class="btn btn-success">{{translate('add')}}</button>
                            <!-- <button type="button" class="btn btn-secondary" @click="close()" data-dismiss="modal">Kapat</button>         -->
                        </div> 
                    </div>
                </div>
                </div>
            </div>
        </div>
        <!-- DETSİS ÜZERİNDEN ALICI SORGULAMA MODALI BAŞLANGIÇ -->
        <div v-if="detsisRequestModal" class="modal fade show" style="display: block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{translate('draftEyp.requestTargetFromDetsis')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" :aria-label="translate('close')" @click="detsisRequestModal = false">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="height:620px;">
                        <div class="form-group row">
                            <label class="col-form-label col-sm-3">{{translate('targetSystem.rem.organizationName')}}</label>
                            <div class="col-sm-9">
                                <select-input
                                    :value="selectedDetsisValue"
                                    :autocomplete="true"
                                    :max-width="selectInputMaxWidth"
                                    :placeholder="translate('search')"
                                    :datasource="detsisUrl"
                                    @change="setDetsisNumber"
                                    >
                                        <span v-if="selectedDetsisValue">{{selectedDetsisValue.Ad}}</span>
                                        <template v-slot:item="{item}">
                                            {{prepareDetsisDisplayName(item)}}
                                        </template>
                                </select-input>
                                <div class="form-help">{{translate('targetSystem.rem.organizationSearchDetsisText')}}</div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-3">{{translate('targetSystem.rem.detsisNo')}}</label>
                            <div class="col-sm-9">
                                <input v-model="DetsisNumber" type="text" class="form-control" />
                                <!-- <div class="text-right">
                                    <button @click="findDetsisBySearch = true" type="button" class="btn btn-link" title="Devlet Teşkilatı Merkezi Kayıt Sistemi üzerinden DETSIS numarası sorgula">DETSIS numarası sorgula</button>
                                </div> -->
                            </div>
                        </div>
                        <h5 class="mt-5">{{translate('draftEyp.contactDetails')}}</h5>
                        <div class="form-group row mt-3">
                            <label class="col-form-label col-sm-3">{{translate('draftEyp.phone')}}</label>
                            <div class="col-sm-3">
                                <input v-model.trim="IletisimBilgisi.Telefon" type="text" class="form-control" />
                            </div>
                            <label class="col-form-label col-sm-3 text-right">{{translate('draftEyp.phone2')}}</label>
                            <div class="col-sm-3">
                                <input v-model="IletisimBilgisi.Telefon2" type="text" class="form-control" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-3">{{translate('draftEyp.email')}}</label>
                            <div class="col-sm-3">
                                <input v-model="IletisimBilgisi.EPosta" type="text" class="form-control" />
                            </div>
                            <label class="col-form-label col-sm-3 text-right">{{translate('draftEyp.fax')}}</label>
                            <div class="col-sm-3">
                                <input v-model="IletisimBilgisi.Faks" type="text" class="form-control" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-3">{{translate('draftEyp.web')}}</label>
                            <div class="col-sm-3">
                                <input v-model="IletisimBilgisi.Web" type="text" class="form-control" />
                            </div>
                            <label class="col-form-label col-sm-3 text-right">{{translate('draftEyp.country')}}</label>
                            <div class="col-sm-3">
                                <input v-model="IletisimBilgisi.Ulke" type="text" class="form-control" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-3">{{translate('draftEyp.province')}}</label>
                            <div class="col-sm-3">
                                <input v-model="IletisimBilgisi.Il" type="text" class="form-control" />
                            </div>
                            <label class="col-form-label col-sm-3 text-right">{{translate('draftEyp.district')}}</label>
                            <div class="col-sm-3">
                                <input v-model="IletisimBilgisi.Ilce" type="text" class="form-control" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-3">{{translate('draftEyp.address')}}</label>
                            <div class="col-sm-9">
                                <input v-model="IletisimBilgisi.Adres" type="text" class="form-control" />
                            </div>
                        </div>
                        
                    </div>
                    <div class="modal-footer footer-button-container">
                        <div>
                            <button type="button" class="btn btn-outline-secondary mr-2" @click="detsisRequestModal = false" data-dismiss="modal">{{translate('close')}}</button>
                            <!-- <button type="button" class="btn btn-primary" @click="saveDetsis(selectedDetsisValue)" data-dismiss="modal">Kaydet</button> -->
                        </div>
                            <button type="button" class="btn btn-success" @click="addDagitimFromModal(selectedDetsisValue)" :disabled="detsisLoading || DetsisNumber == null" data-dismiss="modal">{{translate('add')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- DETSİS ÜZERİNDEN ALICI SORGULAMA MODALI BİTİŞ -->
    </form-container>
</template>

<script>
import axios from 'axios'
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'
import fileUpload from 'vue-upload-component'   // https://lian-yue.github.io/vue-upload-component/#/en/documents#getting-started-npm
import dateInput from '../components/DateInput.vue'
import tab from '../components/Tab.vue'
import tabNav from '../components/TabNav.vue'
import spinner from '@/components/Spinner.vue'
import DateInput from '../components/DateInput.vue';
import SelectInput from './SelectInput.vue';

export default {
    mixins: [formMixin],
    components: {
    formContainer,
    fileUpload,
    SelectInput,
    dateInput,
    tab,
    tabNav,
    spinner
    //axios
    ,
    DateInput
},
    created(){
        this.getOzne({predicate: "IsActive= true", OrderBy:"DisplayName"})
        .then(x => {
            this.ozne = x.Result; 
            this.olusturanList = this.ozne.filter(x=>x.OzneTipi =="OLUSTURAN");
            this.dagitimList = this.ozne.filter(x=>x.OzneTipi =="DAGITIM");
            
            if(!this.olusturanList || this.olusturanList.length == 0 ) {
                alert(this.translate('errors.defineOlusturanOrDagitimToCreateEYP'));
                this.close();
            }

            this.data.OlusturanId = this.olusturanList[0].Id;
            this.generateBelgeNo();
        }).catch(x => {
            console.log("EYP özneleri yüklenemedi:", x);
        });

        this.getData('000000000000000000000000', false).then(() => {
            this.data.DraftId = this.draft.Id
            if(this.olusturanList && this.olusturanList.length == 1)
                this.data.OlusturanId = this.olusturanList[0].Id;
            //console.log('Boş EYP yüklendi.');
        });
    },
    props: {
        draft: Object
    },
    computed: {
        detsisUrl(){
            return window.settings.detsisApiUrl + "Detsis/filterByName";
        },
        totalAttachmentSize(){
            if(this.ekler.length == 0)
                return 0;

            var totalSize = 0;
            for(var i = 0; i < this.ekler.length; i++) {
                totalSize += this.ekler[i].size;
            }
            return totalSize;
        },
        olusturan(){
            if(!this.olusturanList)
                return {};

            return this.olusturanList.filter(x => x.Id == this.data.OlusturanId)[0];
        },
        uploading(){
            return this.ustyaziFile.filter(x => x.active).length > 0 || this.ekler.filter(x => x.active).length > 0;
        },
        categories(){
            return window.epdkCategories;
        },
        qualityCodes(){
            return window.epdkQualityCodes;
        }
    },
    data(){
        return {
            loading: false,
            saving: false,  // Kaydediliyor...
            modelName: 'Eyp2',
            selectInputMaxWidth: '500',
            detsisRequestModal: false,
            detsisRequestInput: null,
            selectedDetsisValue: {},
            IletisimBilgisi : { 
                Telefon : "",
                Telefon2: "",
                EPosta: "",
                Faks : "",
                Web : "",
                Adres : "",
                Il : "",
                Ilce: "",
                Ulke : "",
            },
            DetsisNumber: null,
            detsisResponseData: {
                Items: []
            },
            olusturanList: [],
            dagitimList:[],
            ustyaziAlert: false,
            ozne: [],
            parentCategory: null,
            data: {
                Dagitim: [],
                Ustyazi: {
                    BelgeNo:''
                },
                Metadata: null,
                GuvenlikDerecesi: 'HZO',
                OlusturanId: ''
            },
            ustyaziFile: [],
            metadataFile: [],
            ekler: [],
            uploadHeaders: {
                token: axios.defaults.headers.common['token']
            },
            redirectToList: false,
            detsisLoading: false,
            newDagitim: [],
            tab: 'dosya',
            tabs: [
                { key:'dosya', text: this.translate('tabs.draftEypTabs.file'), visible: () => true },
                { key:'genel', text: this.translate('tabs.draftEypTabs.general'), visible: () => true},
                { key:'epdk', text: this.translate('tabs.draftEypTabs.epdk'), visible: () => this.$root?.$data?.login?.Account?.EpdkCompanyType },
                { key:'dagitim', text: this.translate('tabs.draftEypTabs.dagitim'), visible: () => true }
            ]
        }
    },
    watch: {
         ustyaziFile(oldFiles, newFiles) {
            newFiles.filter(x => x && x.response.document).forEach(element => {
                if(this.data.Documents.filter(d => d.Id == element.response.document.Id).length == 0)
                {
                    this.data.Documents.push(element.response.document);
                    console.log('Documents', this.data.Documents);
                }

                this.$refs.upload.remove(element);
            });
            this.generateBelgeNo();
        },
        metadataFile(oldFiles, newFiles) {
            if(newFiles.length > 0) {
                this.data.Metadata = newFiles[0].response;
                this.parentCategory = this.categories.filter(x => x.subCategories.some(s => s.code == this.data.Metadata.KategoriKodu))[0];
            }
        },
        'data.Metadata.KategoriKodu': function(){
            // Kodu '11.8.5.5' ile başlayan kategorilerde şikayet sahibi haklıdır.
            //console.log('Kategori Kodu Değişti');
            this.data.Metadata.SikayetSahibiHakiMi = this.data.Metadata?.KategoriKodu?.startsWith('11.8.5.5');
        },
    },
    methods: {
        dagitimSelectChanged(value,index){
            const dagitimObject = {
                DagitimTuru: 'BLG',
                Ivedilik: 'NRM',
                IsHedef: true,
                OzneId: value.Id,
                DisplayName: value.DisplayName
            }
            this.newDagitim[index] = dagitimObject
            //nulları cıkar newDagitim'i dagitimList'e at
            //selectinput test et
            this.data.Dagitim = this.newDagitim
            //this.data.Dagitim[0].DisplayName="hoppa";
            this.$forceUpdate();
        },
        // onTabChange(newTab){
        //     console.log('newTab: ', newTab);
        //     this.tab = newTab.key;
        // },
        prepareDetsisDisplayName(item){
            var ustKurum = item.KurumHiyerarsik;
            var replaced = ustKurum.replace(item.Ad,'').trim();
            if(replaced.endsWith('>'))
                replaced = replaced.replace(new RegExp('>' + '$'), '').trim();
            if(replaced)
                replaced = ' ('+replaced+')';
            return item.Ad+ replaced;
        },
        async saveDetsis(selectedDetsis){
            var form = {}
            if(selectedDetsis.Aktifmi == "True"){
                form.IsActive = true
            }else{
                form.IsActive = false
            }
            form.Ad = selectedDetsis.Ad
            form.DetsisNumber = selectedDetsis.DETSISNo
            form.IletisimBilgisi = this.selectedDetsisValue.IletisimBilgisi
            form.Kind = "KurumKurulus"
            form.KurumKimlikKod = selectedDetsis.ParentIdareKimlikKodu.toString()
            form.OzneTipi = "Dagitim"
            await axios.post('/ozne/quickpost', form).then(x => {
                if(x.status != 200){
                    alert(this.translate('errors.ozneSaveFail'))
                }
            })
        },
        addDagitimFromModal(selectedDetsis){
            this.detsisLoading = true;
            this.saveDetsis(selectedDetsis);
            var pushedDagitim = {}
            pushedDagitim.DisplayName = selectedDetsis.Ad
            pushedDagitim.Id = selectedDetsis.Id
            if(selectedDetsis.Aktifmi == "True"){
                pushedDagitim.IsActive = true
            }else{
                pushedDagitim.IsActive = false
            }
            pushedDagitim.Kind = "KurumKurulus"
            pushedDagitim.No = selectedDetsis.DETSISNo.toString()
            selectedDetsis.KurumKimlikKod = selectedDetsis.ParentIdareKimlikKodu.toString()
            selectedDetsis.IletisimBilgisi = this.selectedDetsisValue.IletisimBilgisi
            pushedDagitim.OzneTipi = "DAGITIM"
            if(this.data.Dagitim[0].OzneId == "000000000000000000000000"){
                this.data.Dagitim = []
                this.data.Dagitim.push({
                    DagitimTuru: 'BLG',
                    Ivedilik: 'NRM',
                    IsHedef: true,
                    CustomOzne: selectedDetsis,
                    OzneId: selectedDetsis.Id,
                    DisplayName: selectedDetsis.Ad
                });
            }else{
                this.data.Dagitim.push({
                    DagitimTuru: 'BLG',
                    Ivedilik: 'NRM',
                    IsHedef: true,
                    CustomOzne: selectedDetsis,
                    OzneId: selectedDetsis.Id,
                    DisplayName: selectedDetsis.Ad
                });
            }
            this.dagitimList.push(pushedDagitim)
            this.newDagitim = this.data.Dagitim
            this.detsisLoading = false;

            this.detsisRequestModal = false
        },
        setDetsisNumber(val){
            console.log(val)
            this.selectedDetsisValue = val;
            this.DetsisNumber = val?.DETSISNo;
            this.selectedDetsisValue.KurumKimlikKod = val.AnaKurumIdareKimlikKodu;
            this.getDetsisContactInfo(val.DETSISNo).then((x) => {
                if(!x.data.IsError){
                    this.IletisimBilgisi.Telefon = x.data.Data?.PhoneNumber;
                    this.IletisimBilgisi.Telefon2 = x.data.Data?.SecondPhoneNumber;
                    this.IletisimBilgisi.EPosta = x.data.Data?.Eposta;
                    this.IletisimBilgisi.Faks = x.data.Data?.FaxNumber;
                    this.IletisimBilgisi.Web = x.data.Data?.WebAddress;
                    this.IletisimBilgisi.Adres = x.data.Data?.Address;
                    this.selectedDetsisValue.IletisimBilgisi = this.IletisimBilgisi
                    console.log(this.selectedDetsisValue)
                } 
            this.$forceUpdate();
            })
            .catch(x => {
                console.log("Unvan listesi yüklenemedi:", x);
            });
        },
        generateBelgeNo(){
            if(this.olusturan && this.ustyaziFile && this.ustyaziFile.length > 0) {
                this.data.Ustyazi.BelgeNo = this.olusturan.No + '-' + this.ustyaziFile[0]?.name.split(".")[0];
            }
        },
        setChangedValue(){  
            this.generateBelgeNo(); 
        },
        close(){
            this.$emit('close', this.value);
        },
        addDagitim(){
            this.data.Dagitim.push({
                DagitimTuru: 'BLG',
                Ivedilik: 'NRM',
                IsHedef: true
            });
        },
        removeDagitim(dagitim){
            if(this.saving)
                return;

            this.data.Dagitim = this.data.Dagitim.filter(x => x != dagitim);
            this.newDagitim = this.data.Dagitim
        },
        removeEk(ek) {
            if(ek.success == true){
                if(this.saving)
                    return;
                this.loading = true;
                axios.post(`eyp2/removeAttachment/${this.data.Id}?filename=${ek.name}`)
                .then(x => {
                    if(x.data.Success) {
                        this.ekler = this.ekler.filter(x => x != ek);
                    } else {
                        alert(x.data.ErrorMessages);
                    }
                })
                .catch(x => window.processErrorResponse(x, this))
                .then(() => {
                    this.loading = false;
                });
            }else{
                const updatedEkler = this.ekler.filter(item => item.id !== ek.id);
                this.ekler = updatedEkler
            }
            
        },
        saveEyp(){
            var ekAlert = false;
            if(this.ustyaziFile[0].success == false){
                alert(this.ustyaziFile[0].response.Message)
            }
            for (let i = 0; i < this.ekler.length; i++) {
                if(this.ekler[i].success == false){
                    ekAlert = true;
                }else{
                    ekAlert = false;
                }
            }
            if(ekAlert == true){
                alert(this.translate('errors.attachmentsHaveProblems'))
            }
            if(ekAlert == false){
                this.saving = true;
                this.save().then((x) => {
                    this.saving = false;            
                    if(x && x.status == 200 && x.data) {
                        this.close();
                    }
                })
            }
            
                
        }
    }
}
</script>

<style scoped>
    .remove {
        color:red;
        width:32px;
        background-image: url('data:image/svg+xml,<svg class="bi bi-x-circle" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"/><path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"/></svg>');
        background-repeat: no-repeat;
        background-size: 1rem 1rem;
        content: "";
        background-position: center center;
        cursor: pointer;
    }

    .remove:hover {
        background-image: url('data:image/svg+xml,<svg class="bi bi-x-circle-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">   <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.146-3.146a.5.5 0 0 0-.708-.708L8 7.293 4.854 4.146a.5.5 0 1 0-.708.708L7.293 8l-3.147 3.146a.5.5 0 0 0 .708.708L8 8.707l3.146 3.147a.5.5 0 0 0 .708-.708L8.707 8l3.147-3.146z"/> </svg>');
    }

</style>
<style>
.footer-button-container{
        display: flex;
        width: 100%;
        flex-direction: row;
        align-items: center;
        justify-content: space-between !important;
    }
</style>